import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class UserService {
  private readonly userIdCookieKey = 'user_id';

  constructor(private cookieService: CookieService) {}

  generateUserId(): string {
    const userId = 'user_' + Math.floor(Math.random() * 1000000); // You can replace this with your logic
    this.cookieService.set(this.userIdCookieKey, userId);
    return userId;
  }

  getUserId(): string {
    let userId = this.cookieService.get(this.userIdCookieKey);
    if (userId) {
      return userId;
    } else {
      return this.generateUserId();
    }
  }
  
}
